<!--
  TODO: think about automatic rendering for table cells "td items" no item is passed — N2R6xW7u
-->

<template>
  <td class="name-and-type-cell">
    <RouterLink
      v-if="!selectMode && !singleSelect && areaAccess?.hasWriteAccess"
      :to="`/${apiPathsConfig.edit}/${item.id}`"
      tag="div"
      :class="['font-bold', 'title']"
      component="a"
      @click.stop
    >
      {{item.name}}
    </RouterLink>
    <div v-else>
      {{item.name}}
    </div>
    <div>
      {{ item.description ?? "" }}
    </div>
  </td>
  <td class="min-w-[7rem]">
    <div>
      <component :is="renderers.TimeFormatDateOnly" :epochTime="item.dateLastModified" />
    </div>
  </td>
  <td class="min-w-[7rem]">
    <div>
      <component :is="renderers.TimeFormatDateOnly" :epochTime="item.dateCreated" />
    </div>
  </td>
  <td class="target-players-cell">
    <component :is="renderers.UsedBy" :items="itemTargetPlayers" label="Players" />
  </td>
  <td class="organizations-cell">
    <component :is="renderers.UsedBy" :items="itemOrganizations" label="Organizations" />
  </td>
  <td>
    <div class="flex justify-center">
      <CheckMarkIcon v-if="item.isActive"/>
      <EmptyBoxIcon v-else class="text-gray-500" />
    </div>
  </td>
</template>

<script lang="ts" setup>
import CheckMarkIcon from '@/components/icons/CheckMarkIcon.vue';
import EmptyBoxIcon from '@/components/icons/EmptyBoxIcon.vue';

const props = defineProps<{
  item: any;
  itemIndex: any;
  ItemActionsButtons?: any;
    // TODO (cleaner code / 24-May-2023): think about removing "ItemActionsButtons" prop from "TableListItem" component as it seems not usable at all
      // But check if this will generate any warnings as there's a binded "props" variable in "TableViewItem" in "ItemsList"
  ItemTableSelectBox?: any;
  columnsConfig: any;
  renderers: any;
  filteredListItems: any;
  apiPathsConfig?: any;
  listerConfig?: any;
  selectMode?: boolean;
  singleSelect?: boolean;
  // TODO (cleaner code / 24-May-2023): investigate more how we can separate & import prop definition and if it'll be a good code design — N5OLATD3
}>();

const {
  areaAccess
} = props.listerConfig;

const itemOrganizations = props.item?.filters?.filter(i=>i.organization != null)?.map(i=> i.organization)
const itemTargetPlayers = props.item?.matchedPlayers?.map(i=>i.player);
</script>

<style lang="scss" scoped>
.title {
  color: #25294A;
  text-decoration: none;
  cursor: pointer;
  max-width: 200px;
  display: inline-block;
}
.title:hover {
  text-decoration: underline;
}

.name-and-type-cell {
  word-break: break-word;
  min-width: 10rem;
}

.target-players-cell {
  display: flex;
  justify-content: center;
  :deep(.used-by-container) {
    width: fit-content;
    margin-right: 1.5rem;
    padding: 0.5rem;
  }
}
</style>